import {NotificationData, Observer} from '../Notifier';
import Status from '../Status';

import l10n from 'diy/util/l10n';

interface PagesEditorNotification {
    title: string;
    message: string;
    actionText: string;
    actionHandler? (): void;
}

class PagesEditorObserver implements Observer {
    status: string;
    removed = false;
    message: PagesEditorNotification;

    notify(data: NotificationData) {
        this.message = {
            title: l10n('migration.pageseditor.notification.title'),
            message: l10n('migration.pageseditor.notification.text'),
            actionText: l10n('migration.pageseditor.notification.button'),
            actionHandler: data.actionHandler
        };
        this.status = data.status;
    }

    remove() {
        this.removed = true;
    }

    isRemoved(): boolean {
        return this.removed;
    }

    isDeclined(): boolean {
        return (!this.isRemoved() && this.status === Status.SKIPPED);
    }

    isCompleted(): boolean {
        return (!this.isRemoved() && this.status === Status.SUCCESS);
    }

    getMessage(): PagesEditorNotification {
        return this.message;
    }
}

export let pagesEditorObserver = new PagesEditorObserver;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/NotifierObservers/PagesEditorObserver.ts
 **/